import { Spinner } from './Spinner';

export const PageLoader = () => (
	<div className="flex justify-center items-center">
		<Spinner />
	</div>
);
